module.exports = __webpack_public_path__ + "media/images/flags/GQ-c6f7d9c326d61a164278ad5e5bbc607b.svg";